import { useState } from "react";
import { Building2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

interface PropertyImageProps {
  src?: string | null;
  alt?: string;
  className?: string;
  imgClassName?: string;
  fallbackIconSize?: number;
  showWatermark?: boolean;
  watermarkSize?: "sm" | "md" | "lg";
}

const PropertyImage = ({
  src,
  alt = "",
  className,
  imgClassName,
  fallbackIconSize = 32,
}: PropertyImageProps) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const hasPhoto = !!src && !error;

  return (
    <div className={cn("relative overflow-hidden bg-muted", className)}>
      {hasPhoto ? (
        <>
          {/* Skeleton / blur-up placeholder */}
          {!loaded && (
            <Skeleton className="absolute inset-0 w-full h-full rounded-none animate-pulse" />
          )}
          <img
            src={src}
            alt={alt}
            className={cn(
              "w-full h-full object-cover transition-all duration-700 ease-out",
              loaded ? "blur-0 scale-100" : "blur-md scale-105 opacity-0",
              imgClassName
            )}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            onError={() => setError(true)}
          />
        </>
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <Building2 className="text-muted-foreground" size={fallbackIconSize} />
        </div>
      )}
    </div>
  );
};

export default PropertyImage;
